import {Component} from '@angular/core';
import {JasoIndexComponent} from "../../shared/components/jaso-index/jaso-index.component";

@Component({
  selector: 'app-jaso-index-homonym',
  templateUrl: '../../shared/components/jaso-index/jaso-index.component.html',
  styleUrls: ['../../shared/components/jaso-index/jaso-index.component.scss'],
})
export class JasoIndexHomonymComponent extends JasoIndexComponent {
}
